export const SET_LOADING = 'SET_LOADING';
export const SET_SELECTED_STATE_FIPS = 'SET_SELECTED_STATE_FIPS';
export const SET_COMPARISON_STATE_FIPS = 'SET_COMPARISON_STATE_FIPS';
export const SET_SELECTED_COUNTY_FIPS = 'SET_SELECTED_COUNTY_FIPS';
export const SET_COMPARISON_COUNTY_FIPS = 'SET_COMPARISON_COUNTY_FIPS';
export const SET_SELECTED_COST = 'SET_SELECTED_COST';
export const SET_SUMMARY_TYPE = 'SET_SUMMARY_TYPE';
export const SET_DISPLAY_TYPE = 'SET_DISPLAY_TYPE';
export const SET_NATIONAL_DATA = 'SET_NATIONAL_DATA';
export const SET_STATES_DATA = 'SET_STATES_DATA';
export const SET_COUNTIES_DATA = 'SET_COUNTIES_DATA';
